import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EdapModuleView from '../EdapModuleView';
import TrendingCard from './TrendingCard';
import Carousel from '../Carousel';
import TrendingModal from './TrendingModal';

import { FormattedMessage } from '../Intl';
import { messageKeys, getLabels } from './translations';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';

import {
  TRENDING_DESTINATION_LINK_CLICK,
  TRENDING_CLICK_PREV,
  TRENDING_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

import './Trending.less';

const DEFAULT_STATE = {
  isOpen: false,
  locationQuery: '',
  url: {
    slpUrl: '',
    serpUrl: ''
  }};

class Trending extends Component {
  static propTypes = {
    edapModuleViewEventOptions: PropTypes.shape({ actionlocation: PropTypes.string }),
    showTrendingModal: PropTypes.bool,
    tiles: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  static defaultProps = {
    tiles: []
  }

  state = DEFAULT_STATE;

  // Arrow handlers
  handlePreviousClick() {
    triggerEdapEvent(TRENDING_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(TRENDING_CLICK_NEXT);
  }

  // Modal
  handleOpenModal = ({ lbsId, slpUrl, serpUrl, locationQuery }) => (evt) => {
    evt.preventDefault();
    triggerEdapEvent(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid: lbsId });
    this.setState({ isOpen: true, url: { slpUrl, serpUrl }, locationQuery });
  }

  handleCloseModal = () => {
    this.setState({ ...DEFAULT_STATE });
  }

  render() {
    const {
      edapModuleViewEventOptions,
      tiles,
      showTrendingModal
    } = this.props;

    const { isOpen, locationQuery, url } = this.state;

    return (
      tiles && tiles.length > 0 &&
        <section className="Content__section">
          <EdapModuleView eventOptions={edapModuleViewEventOptions || MODULE_VIEW_EVENT_OPTIONS} >
            <FormattedMessage id={messageKeys}>
              {(...messages) => (
                <TrendingModal
                  isOpen={isOpen}
                  locationQuery={locationQuery}
                  url={url}
                  handleClose = {this.handleCloseModal}
                  labels = {getLabels(...messages)}
                />
              )}
            </FormattedMessage>
            <FormattedMessage id={'component.trending.destinations.heading'}>
              {(title) => {
                return (
                  <Carousel
                    title={title}
                    onPreviousClick={this.handlePreviousClick}
                    onNextClick={this.handleNextClick}
                  >
                    {tiles.map(item => (
                      <TrendingCard key={item.lbsId} onClick={showTrendingModal ? this.handleOpenModal(item) : handleEdapClick(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid: item.lbsId })} {...item} />
                    ))}
                  </Carousel>
                );
              }}
            </FormattedMessage>
          </EdapModuleView>
        </section>
    );
  }
}

export default Trending;
